import { SET_NOTIFICATION, CLOSE_NOTIFICATION } from './actionTypes';

export const setNotification = (notification) => ({ type: SET_NOTIFICATION, notification });

export const closeNotification = () => ({ type: CLOSE_NOTIFICATION });
